import { getDataMapper, mapField } from "@/shared";

export const mapTariffDataToServer = getDataMapper({
    tariff_id: mapField("tariffId", Number),
    payment_service: mapField("paymentService", String),
    promocode: mapField("promocode"),
    use_bonus: mapField("useBonus", Boolean),
});
